import script from "./memorialhall.vue?vue&type=script&setup=true&lang=ts"
export * from "./memorialhall.vue?vue&type=script&setup=true&lang=ts"

import "./memorialhall.vue?vue&type=style&index=0&id=00aa2c52&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00aa2c52"]])

export default __exports__